import React from "react";

import SiteLocationForm from "./SiteLocationForm";

const AddSiteLocation = () => {
  return <SiteLocationForm mode="create" />;
};

export default AddSiteLocation;
